// extracted by mini-css-extract-plugin
module.exports = {"gsapb":"riverpro_gsapb__r_0O9"};